

import React, { lazy, Suspense } from "react";
import {  Route, Routes } from "react-router-dom";
import { Path } from "./routes";
//import ProtectedRoute from "../store/ProtectedRoute";
 
const Maintenance = lazy(() => import("../pages/home/MaintenancePage"));

const NotFound = lazy(() => import("../pages/404"));
const Home = lazy(() => import("../pages/home"));
const About = lazy(() => import("../pages/about"));
const ContactUs = lazy(() => import("../pages/contact"));
const Events = lazy(() => import("../pages/event"));
const Admission = lazy(() => import("../pages/admission"));




const RouterConfig = () => {

  return (
    <Suspense
    //fallback={<Loader />}
    >
      <Routes>
        <Route path={Path.Maintenance} element={<Maintenance />} />
        <Route path={Path.Home} element={<Home />} />
        <Route path={Path.ContactUs} element={<ContactUs />} />
        <Route path={Path.About} element={<About />} />
       <Route path={Path.Events} element={<Events />} />
        <Route path={Path.Admission} element={<Admission />} />
       



        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )

}

export default RouterConfig;